<mat-card class="menupannel">
  <div class="resUser">

    <button mat-flat-button [routerLink]="'/filemanager/inbox'">
      <mat-icon color="primary" >inbox</mat-icon> Inbox
    </button>
    <!-- (click)="showMyDrive()" -->
    <button mat-flat-button [routerLink]="'/filemanager'" >
      <mat-icon color="primary" >add_to_drive</mat-icon> My Drive 
    </button>

    <button mat-flat-button (click)="getSharedWithMe()"  [routerLink]="'/filemanager/'" >
      <mat-icon color="primary" >portrait</mat-icon> Shared with me
         
    </button>

  </div>
  <div class="d">
    <!-- <button mat-flat-button (click)="showDocDetail()">
      <mat-icon>keyboard_arrow_left</mat-icon> Details
    </button> -->
  </div>
</mat-card>

<div class="coreholder" fxLayout="row">
  <!-- My Drive -->
  <mat-card class="myDrive" [ngClass]="{'open': showmyDrive }">
    <app-left-menu></app-left-menu>
  </mat-card>
  <div class="myDriveOverlay" (click)="showMyDrive()" [ngClass]="{'open': showmyDrive }"></div>
  <!-- My Drive -->

  <!-- Core page Structure -->
  <div class="corepages">


    <router-outlet></router-outlet>

  </div>
  <!-- Core page Structure -->
  <!-- Document Detail  -->
  <mat-card class="documentDetail" [ngClass]="{'open': docDetail }">
    <div class="docDetail">
      <app-doc-detail></app-doc-detail>
    </div>
  </mat-card>
  <div class="documentDetailOverlay" (click)="showDocDetail()" [ngClass]="{'open': docDetail }"></div>
  <!-- Document Detail -->

  

  <ng-template #createFileManagerFolder>
    <form  [formGroup]="formDialog">  
      <h2 mat-dialog-title>
        <span class="groupIcon"><mat-icon>create_new_folder</mat-icon></span>
        Create Folder              
        <button mat-icon-button (click)="close()">
          <mat-icon>close</mat-icon>
        </button>        
      </h2>   
          
    <mat-dialog-content class="mat-typography">
      <mat-form-field class="example-full-width">
          <mat-label>Folder Name</mat-label>
          <input matInput [required]="true"  placeholder="Add folder name" formControlName="filemanagerFolderName"/>
          <mat-error
          *ngIf="
            formDialog.get('filemanagerFolderName').invalid &&
            (formDialog.get('filemanagerFolderName').dirty ||
            formDialog.get('filemanagerFolderName').touched)">
          <span>This field is mandatory.</span>
        </mat-error>
        </mat-form-field>
    
    
    </mat-dialog-content>
    
    <mat-dialog-actions class="dialog-actions">
      <button mat-button (click)="close()">Cancel</button>
      <button mat-flat-button color="primary" [disabled]="formDialog.invalid" 
      (click)="AddFolderName(formDialog.value)">Create</button>
    </mat-dialog-actions>
    
      </form>
  </ng-template>
      

</div>





<!-- <ng-template #addFolderDialog>
  <h2 matDialogTitle>Share with</h2>
  <mat-dialog-content>

    <form>

      <mat-radio-group aria-label="Select an option">
        <mat-radio-button color="primary" value="1">Contact</mat-radio-button>
        <mat-radio-button  color="primary" value="2">Role</mat-radio-button>
      </mat-radio-group>

      <mat-form-field class="mt-10">
        <mat-label>Select</mat-label>
        <input matInput placeholder="" >
      </mat-form-field>

    
    </form>

  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" >Cancel</button>
    <button mat-button color="primary" >Share</button>
  </mat-dialog-actions>
</ng-template> -->





<ng-template #addFolderDialog>
  <h2 mat-dialog-title>
     <span class="groupIcon" ><mat-icon>group_add</mat-icon></span>
      Share with Contact and Role 
      
        <button mat-icon-button (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </h2>
  
<mat-dialog-content class="mat-typography">

  <!-- <mat-form-field appearance="fill">
    <mat-label>Add people and groups</mat-label>
    <mat-select>
      <mat-option value="option">Option</mat-option>
    </mat-select>
  </mat-form-field> -->

  <mat-form-field  appearance="fill">
    <input matInput
           placeholder="Add Contact or Role"
           aria-label="State"
           [matAutocomplete]="auto"
           [formControl]="stateCtrl">
    <mat-autocomplete #auto="matAutocomplete">
      <mat-option  *ngFor="let state of filteredStates | async" [value]="state.name">
        <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
            <div class="pic">
                <img class="" [src]="state.pic"/>
            </div>
            <span fxLayout="column" fxLayoutAlign="flex-start"> 
                <b>{{state.name}} </b>
                <small>{{state.email}}</small>
            </span> 
        </span>
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>


  <ul class="selectedlist" >
    
    <li *ngFor="let user of peoples" >
      <div class="userndetail">
          <div class="pic">
            <img src="../../../assets/images/avatars/{{user.img}}" alt="" >
          </div>
          <div class="detail">
              <h4>{{user.name}}</h4>
              <p>{{user.email}}</p>
          </div>
      </div>
      <div class="option">
        <button mat-flat-button [matMenuTriggerFor]="menu"  aria-label="Permission">
          <mat-icon>visibility</mat-icon>Viewer
        </button>
        <mat-menu #menu="matMenu" xPosition="before">
          <button disabled mat-menu-item>
            <mat-icon>visibility</mat-icon>
            <span>Viewer</span>
          </button>
          <button mat-menu-item >
            <mat-icon>text_fields</mat-icon>
            <span>Editor</span>
          </button>
          <button mat-menu-item>
            <mat-icon>delete</mat-icon>
            <span>Remove</span>
          </button>
        </mat-menu>
      </div>
    </li>
   
  </ul>

  
</mat-dialog-content>
<mat-dialog-actions >
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary" >Done</button>
</mat-dialog-actions>
</ng-template>

<app-loader></app-loader>